"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.locationQueryCandidates = locationQueryCandidates;
function locationQueryCandidates(parts) {
    const place = parts.place?.trim() ?? '';
    const city = parts.city?.trim() ?? '';
    const country = parts.country?.trim() ?? '';
    const strippedPlace = place
        .replace(/^(?:село|город|деревня|посёлок|поселок|станица|хутор|аул|район|область|край|республика|штат|провинция|регион)\s+/i, '')
        .trim();
    const components = [place, city, country].filter(Boolean);
    const uniqueComponents = [...new Set(components)];
    const candidates = [
        uniqueComponents.join(', '),
        [city, country].filter(Boolean).join(', '),
        place,
        strippedPlace,
        country,
    ];
    const seen = new Set();
    return candidates.filter((candidate) => {
        if (!candidate || seen.has(candidate))
            return false;
        seen.add(candidate);
        return true;
    });
}
//# sourceMappingURL=location.js.map